// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1TkEO","content":"style_content__GWx08","msg":"style_msg__33-m_","HomeBtn":"style_HomeBtn__1awvj"};